import { defineStore } from 'pinia'
// import { ref } from 'vue'
// 你可以对 `defineStore()` 的返回值进行任意命名，但最好使用 store 的名字，同时以 `use` 开头且以 `Store` 结尾。(比如 `useUserStore`，`useCartStore`，`useProductStore`)
// 第一个参数是你的应用中 Store 的唯一 ID。
export const useAlertsStore = defineStore('alert1', {
    // 其他配置...
    state: () => {
        return {
            info: {
                title: '',
                projectType: '',
                subjectType: '',
                topicName: '',
                subjectWord: '',
                researchType: '',
                expectedResult: '',
                totalWords: '',
                applyDate:'',
                applyFunds:'',
                finishDate:'',
            },

        }
    },
    actions: {
        loadFormDataFromLocalStorage() {
            const storedData = JSON.parse(localStorage.getItem('info')) || {}
            this.info = { ...this.info, ...storedData }
        },
        saveFormDataToLocalStorage() {
            localStorage.setItem('info', JSON.stringify(this.info))
        },
        setInfo(info) {
            this.info = info
        },
        clearFormData() {
            localStorage.removeItem('info')
            this.info = {
                title: '',
                projectType: '',
                subjectType: '',
                topicName: '',
                subjectWord: '',
                researchType: '',
                expectedResult: '',
                totalWords: '',
                applyDate:'',
                applyFunds:'',
                finishDate:'',
            }
        },
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'info',
                storage: localStorage,
            },
        ],
    }

})